import { Toast, ToastContainer } from "react-bootstrap";

const BasicToast = ({ isShown, setIsShown, bodyMessage }) => {
  return (
    <ToastContainer position='bottom-center'>
      <Toast
        bg='primary'
        show={isShown}
        onClose={() => setIsShown(false)}
        animation={true}
      >
        <Toast.Header closeButton={true}>
          <strong>{bodyMessage}</strong>
        </Toast.Header>
      </Toast>
    </ToastContainer>
  );
};

export default BasicToast;
